import { useState } from 'react';

// Lightweight contact form modal. Interim: composes an email to Inspect Canada's
// monitored inbox (with the inspector named) so it always delivers. Swap to a
// server-side POST (per-inspector routing + lead logging) when that's built.
const CONTACT_INBOX = 'fastreply@inspect.ca';

export default function ContactModal({ inspectorName, onClose }: { inspectorName: string; onClose: () => void }) {
  const [f, setF] = useState({ name: '', email: '', phone: '', message: '' });

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Website inquiry for ${inspectorName}`);
    const body = encodeURIComponent(
      `Inquiry for: ${inspectorName}\n\nName: ${f.name}\nEmail: ${f.email}\nPhone: ${f.phone}\n\n${f.message}`,
    );
    window.location.href = `mailto:${CONTACT_INBOX}?subject=${subject}&body=${body}`;
    onClose();
  };

  const field = 'w-full border border-slate-300 rounded-lg px-3 py-2 text-sm text-ink focus:outline-none focus:ring-2 focus:ring-accent/40';

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-1">
          <h3 className="text-xl font-extrabold text-navy">Contact {inspectorName}</h3>
          <button onClick={onClose} aria-label="Close" className="text-slate-400 hover:text-slate-700 text-2xl leading-none -mt-1">×</button>
        </div>
        <p className="text-sm text-slate-500 mb-4">Send a message and the Inspect Canada team will connect you with {inspectorName}.</p>
        <form onSubmit={submit} className="space-y-3">
          <input required placeholder="Your name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={field} />
          <input required type="email" placeholder="Your email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={field} />
          <input placeholder="Phone (optional)" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className={field} />
          <textarea required rows={4} placeholder="How can we help?" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} className={field} />
          <button type="submit" className="w-full bg-accent hover:bg-accent-dark text-white font-semibold py-2.5 rounded-xl transition-colors">Send message</button>
        </form>
      </div>
    </div>
  );
}
